import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";

import useStyles from "./styles";
import DialogBottom from "components/DialogBottom";
import theme from "theme";
import clsx from "clsx";

const ConfirmRewardDialog = memo(props => {
	const classes = useStyles();
	const { open, crmRewardDetail, handleClose, handleConfirm } = props;

	return (
		<DialogBottom open={open} handleClose={handleClose}>
			<Grid classes={{ root: classes.subTitle }}>
				Xác nhận trả thưởng
			</Grid>
			<Grid classes={{ root: classes.title }}>
				{crmRewardDetail?.name || ""}
			</Grid>
			<Grid classes={{ root: classes.driver }} />
			<Grid container classes={{ root: classes.rootItem }}>
				<Grid item xs={6} classes={{ root: classes.titleItem }}>
					Chỉ tiêu
				</Grid>
				<Grid item xs={6} classes={{ root: classes.price }}>
					{formatCash(crmRewardDetail?.achievedSales)} Đ
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.driver }} />
			<Grid container classes={{ root: classes.rootItem }}>
				<Grid item xs={6} classes={{ root: classes.titleItem }}>
					Thực hiện
				</Grid>
				<Grid item xs={6} classes={{ root: classes.price }}>
					{formatCash(crmRewardDetail?.currentSales)} Đ
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.driver }} />
			<Grid container classes={{ root: classes.rootDiscount }}>
				<Grid
					item
					xs={8}
					classes={{ root: classes.titleItem }}
					style={{
						color: theme.palette.primary.contrastText,
						fontSize: 15
					}}
				>
					Chiết khấu được thưởng
				</Grid>
				<Grid
					item
					xs={4}
					classes={{ root: classes.price }}
					style={{ fontSize: 16 }}
				>
					{formatCash(crmRewardDetail?.discount)} Đ
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.note }}>
				Tôi xác nhận đã nhận đủ số tiền trả thưởng từ chương trình
			</Grid>
			<Grid container spacing={1}>
				<Grid item xs={6}>
					<Grid
						classes={{ root: classes.btnCancel }}
						onClick={() => handleClose()}
					>
						Đóng
					</Grid>
				</Grid>
				<Grid item xs={6}>
					<Grid
						component="button"
						classes={{
							root: clsx(classes.btnConfirm)
						}}
						onClick={() => handleConfirm()}
					>
						Xác nhận
					</Grid>
				</Grid>
			</Grid>
		</DialogBottom>
	);
});

export default ConfirmRewardDialog;
